// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__3LCEf","load2":"Spinner_load2__29s5E"};